import { Link, useLocation } from "react-router-dom";

const SHIELD_URL = "/honeystone-shield.png";

export default function Header() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <header className="w-full border-b border-[#E5E0D8] bg-[#F9F8F6]/90 backdrop-blur-sm sticky top-0 z-30" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="header-home-link">
          <img src={SHIELD_URL} alt="Honeystone Home & Garden" className="h-12 w-12 sm:h-14 sm:w-14 object-contain shrink-0" />
          <span className="font-[Outfit] font-semibold text-[#2C3E35] text-lg tracking-tight leading-none">
            Honeystone <span className="text-[#86A789]">Home &amp; Garden</span>
          </span>
        </Link>
        <nav className="hidden sm:flex items-center gap-6 text-sm font-medium">
          <Link to="/" className="text-[#2C3E35]/80 hover:text-[#4F6F52] transition-colors" data-testid="nav-home">Home</Link>
          <Link to="/quote" className="text-[#2C3E35]/80 hover:text-[#4F6F52] transition-colors" data-testid="nav-quote">Get a Quote</Link>
          <Link to="/status" className="text-[#2C3E35]/80 hover:text-[#4F6F52] transition-colors" data-testid="nav-status">My Quote</Link>
          {!isAdmin && (
            <Link to="/admin/login" className="text-[#2C3E35]/60 hover:text-[#4F6F52] transition-colors" data-testid="nav-admin">Admin</Link>
          )}
        </nav>
      </div>
    </header>
  );
}
